/*
 Created by CHT 2019/8/23 16:42
 1、获取token
 2、传入formData
 3、使用token 和 formData 上传文件
 */

import * as qiniu from 'qiniu-js'
import SparkMD5 from 'spark-md5'

function FileUpload({files, companyId}) {
  this.files = files
  this.companyId = companyId
  this.filesMap = {}
}

// prototype

// 文件是否存在
FileUpload.prototype.exists = 1
FileUpload.prototype.fileInfo = async function (file) {
  const md5 = await FileUpload.MD5fileSync(file)
  const lastIndex = file.name.lastIndexOf('.')
  this.filesMap[md5] = file
  return {
    fileName: file.name.substring(0, lastIndex),
    fileFolder: '',
    fileType: file.name.substring(lastIndex + 1) || '',
    fileCategory: file.type,
    mimeType: file.type,
    fileSize: file.size,
    fileMD5: md5,
    fileCrc32: ''
  }
}
FileUpload.prototype.upload = function () {
  const fileKeyList = []
  let fileUrl = ''
  const files = this.files.map(file => {
    return this.fileInfo(file)
  })
  return Promise.all(files)
    .then(files => {
      if (FileUpload.getToken) {
        return FileUpload.getToken({
          files,
          companyId: this.companyId
        })
      } else {
        throw new Error('getToken of null')
      }
    })
    .then(result => {
      fileUrl = result.accessUrl
      return result.files.filter(res => {
        const isExisting = res.fileExists === this.exists
        fileKeyList.push(res.fileKey)
        return !isExisting
      })
    })
    .then(resultList => {
      return Promise.all(resultList.map(result => {
        return FileUpload.qn({
          file: this.filesMap[result.fileMD5],
          token: result.uploadToken,
          key: result.oriKey
        })
      }))
    })
    .then(list => {
      return fileKeyList.map(fileKey => `${fileUrl}/${fileKey}`)
    })
}

// 上传七牛逻辑
FileUpload.qn = function ({file, token, key}) {
  const opt = {
    file: file,
    key: key,
    token: token,
    putExtra: {
      fname: ``,
      params: {},
      mimeType: null
    },
    config: {
      useCdnDomain: true,
      region: null
    }
  }
  const observable = qiniu.upload(opt.file, opt.key, opt.token, opt.putExtra, opt.config)
  return new Promise((resolve, reject) => {
    observable.subscribe({
      error(err) {
        reject(err)
      },
      complete(res) {
        resolve(``)
      }
    })
  })
}

// 文件MD5
FileUpload.MD5fileSync = function (file) {
  const blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice
  const chunkSize = 2097152                             // Read in chunks of 2MB
  const chunks = Math.ceil(file.size / chunkSize)
  let currentChunk = 0
  const spark = new SparkMD5.ArrayBuffer()
  const fileReader = new FileReader()
  const promise = new Promise((resolve, reject) => {
    fileReader.onload = function (e) {
      spark.append(e.target.result)                   // Append array buffer
      currentChunk++

      if (currentChunk < chunks) {
        loadNext()
      } else {
        resolve(spark.end())
      }
    }

    fileReader.onerror = function (err) {
      reject(err)
    }
  })

  function loadNext() {
    const start = currentChunk * chunkSize
    const end = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize

    fileReader.readAsArrayBuffer(blobSlice.call(file, start, end))
  }

  loadNext()
  return promise
}

// 获取token的函数
FileUpload.getToken = null

// 实例并上传文件
FileUpload.upload = function (files, companyId) {
  return new FileUpload({
    files: Array.from(files),
    companyId
  }).upload()
}

// base64 转 Flie
FileUpload.base64ToFile = function (dataUrl, filename) {//将base64转换为文件
  const arr = dataUrl.split(',')
  const mime = arr[0].match(/:(.*?);/)[1]
  const bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], filename, {type: mime})
}

FileUpload.qiniu = qiniu
FileUpload.SparkMD5 = SparkMD5

export default FileUpload
